export const ChangeGlobalVariableOrder2 =  ()=>{
    return (
        <div className="container">
            <h2>変数変動順番相手</h2>
           <p>非推奨です</p>
        </div>
    )
}